import AppLayout from "@/layouts/AppLayout";
import { Outlet, useLocation } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";
import TabLayout from "./_TabLayout";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { isBackgroundCheckFocusedPagePath } from "@/features/person/components/BackgroundCheckOrders/backgroundCheckPaths";

export default function MembershipLayout() {
  const location = useLocation();
  const isBackgroundCheckFocusedPage = isBackgroundCheckFocusedPagePath(location.pathname);
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();

  if (shouldRenderError || !pgaId) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  if (isBackgroundCheckFocusedPage) {
    return <Outlet />;
  }

  const renderDesktopLayout = () => (
    <>
      <PersonObjectHeading pgaId={pgaId} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        compactOnly
        compactTitle="Membership"
        backLink={{ to: "/people/:pgaId", params: { pgaId: pgaId! } }}
      />
      <PersonObjectHeading pgaId={pgaId} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
